import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const sliderContainer = style({
  display: "flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["2x"],
  flexShrink: 0
});

export const sliderTrackBackground = style({
  width: "120px",
  height: primitiveTokens.sizing["6x"],
  padding: "0 2px",
  boxSizing: "border-box",
  borderRadius: "9999px",
  background: primitiveTokens.colors.gradients.sliderTrack,
  display: "flex",
  alignItems: "center"
});

export const sliderRoot = style({
  position: "relative",
  display: "flex",
  alignItems: "center",
  userSelect: "none",
  touchAction: "none",
  width: "100%",
  height: "100%",
  cursor: "pointer",

  selectors: {
    "&[data-disabled]": {
      cursor: "not-allowed"
    }
  }
});

export const sliderTrack = style({
  position: "relative",
  flexGrow: 1,
  height: primitiveTokens.sizing["6x"],
  background: "transparent"
});

export const sliderRange = style({
  position: "absolute",
  height: "100%",
  background: "transparent"
});

export const sliderThumb = style({
  position: "relative",
  display: "block",
  width: primitiveTokens.sizing["5x"],
  height: primitiveTokens.sizing["5x"],
  backgroundColor: semanticThemeTokens.switch.thumb.backgroundColor,
  borderRadius: "9999px",
  outline: "none",

  selectors: {
    "&:focus-visible": {
      boxShadow: primitiveTokens.colors.shadow.focusRing
    },
    "&[data-disabled]": {
      cursor: "not-allowed"
    }
  }
});

export const sliderTooltip = style({
  position: "absolute",
  bottom: "calc(100% + 4px)",
  left: "50%",
  transform: "translateX(-50%)",
  padding: "2px 6px",
  borderRadius: primitiveTokens.sizing["1x"],
  backgroundColor: semanticThemeTokens.switch.label.textColor,
  color: semanticThemeTokens.switch.thumb.backgroundColor,
  fontSize: primitiveTokens.type.sm,
  lineHeight: primitiveTokens.type.sm,
  whiteSpace: "nowrap",
  pointerEvents: "none",
  opacity: 0,
  transition: "opacity 0.1s ease",

  selectors: {
    [`${sliderThumb}:hover &, ${sliderThumb}:focus-visible &, ${sliderThumb}:active &`]:
      {
        opacity: 1
      }
  }
});

export const sliderLabel = style({
  color: semanticThemeTokens.switch.label.textColor,
  fontSize: primitiveTokens.type.sm,
  lineHeight: primitiveTokens.type.sm
});
